import react from "react";
import { useUser } from "./useUser";
import SmallHeaderCard from "@/components/SmallHeaderCard";
import AdminLineItem from "@/components/AdminLineItem";
import typo from "@/styles/Typography.module.css";
import { NavLink } from "react-router-dom";

export default function SurveyManager() {
  const user = useUser();
  console.log("SurveyManager user:", user);

  return (
     <AdminLineItem title="Monitoring Management" user={user}>
          <div className="mb-4">
            <h1 style={{color: "#F16D09", paddingBottom: "2.5rem", marginTop: "3rem"}}>Monitoring Management</h1>
          </div>
      <div>
       {/* Monitoring section */}
               <div className="row g-1">
      <div>
          <div style={{ paddingTop: ".5rem", marginTop: "2rem"}}>
            <p style={{ textAlign: "left", paddingLeft: ".5rem", color: "#F16D09", fontSize: "var(--font-heading-sm )"}}>
MONITORING TOOLS            </p>
          </div>
        </div>
              <div>
                <div className={typo.cardWhite_narrow} style={{ paddingTop: ".5rem"}}>
                 <NavLink
                             to="/admin/monitoring/surveyMonitor"
                             className={({ isActive }) => (isActive ? typo.navLinkActive : "")}
                             style={{ display: "block", padding: ".5rem", textDecoration: "none", color: "inherit", textAlign: "left" }}
                           >
                            Survey monitoring - See who has responded, and who hasn't, live surveys etc
                           </NavLink> 
                   </div>
              </div>
              <div>
              </div>
              </div>
              </div>
        </AdminLineItem>
    );
};